import React from 'react'
import ReactDOM from 'react-dom'
import { AppContainer } from 'react-hot-loader'
import injectTapEventPlugin from 'react-tap-event-plugin'
import AppService from './services/AppService'
import Root from './components/Root'
import './entry'
import './lib/polyfill.object'
import './styles/layout.less'

injectTapEventPlugin()

const app = new AppService()
const { store, history } = app

ReactDOM.render(
	<AppContainer>
		<Root store={store} history={history} />
	</AppContainer>,
	document.getElementById('root')
)

if (module.hot) {
	module.hot.accept('./components/Root', () => {
		// eslint-disable-next-line global-require
		const NewRoot = require('./components/Root').default
		ReactDOM.render(
			<AppContainer>
				<NewRoot store={store} history={history} />
			</AppContainer>,
			document.getElementById('root')
		)
	})
}



// WEBPACK FOOTER //
// ./src/entry.app.jsx